export enum OrderRateType {
  FREIGHT = 'freight',
  TONNE = 'tonne',
  EVERY_KILOMETER = 'every-kilometer',
  LOADED_KILOMETER = 'loaded-kilometer',
  CUBIC_METER = 'cubic-meter',
}
